// Team group model: 1 = Faction, 2 = Guild, null/undefined = "Other" (default).
// Group reaches the client as an integer or null (Newtonsoft serializes enums as ints).
export const TEAM_GROUP_LABELS = { 1: 'Faction', 2: 'Guild' }

// Display order of the group headers. null is the "Other" bucket, shown last.
export const TEAM_GROUP_ORDER = [1, 2, null]

const normalizeGroup = group => (group === undefined ? null : group)

export function teamGroupLabel(group) {
    return TEAM_GROUP_LABELS[normalizeGroup(group)] || 'Other'
}

// Transform a flat team list into a Vuetify select/autocomplete items array with
// non-selectable subheaders. Team entries are returned unchanged so callers keep
// their existing item-value / item-text bindings.
export function groupTeamsForSelect(teams, { nameKey = 'name', groupKey = 'group', leadingItems = [] } = {}) {
    const items = [...leadingItems]
    const source = teams || []
    for (const group of TEAM_GROUP_ORDER) {
        const inGroup = source
            .filter(t => normalizeGroup(t[groupKey]) === group)
            .sort((a, b) =>
                String(a[nameKey] || '')
                    .toLowerCase()
                    .localeCompare(String(b[nameKey] || '').toLowerCase()),
            )
        if (inGroup.length === 0) continue
        items.push({ header: teamGroupLabel(group) })
        items.push(...inGroup)
    }
    return items
}
